/* eslint-disable react/no-multi-comp, max-lines, max-len */
import { FormattedMessage } from 'react-intl'
import React from 'react'

export const RESERVE_IN_PROGRESS = (timeNode) => (
    <FormattedMessage
        id='reserve_select_item.status.in_progress'
        defaultMessage='In progress (will be ready: {timeNode})'
        values={{
            timeNode,
        }}
    />
)

export const RESERVE_DELAYED = (order, timeNode) => (
    <FormattedMessage
        id='reserve_select_item.status.delayed'
        defaultMessage='In queue: {order} (will be ready: {timeNode})'
        values={{
            order,
            timeNode,
        }}
    />
)


// WEBPACK FOOTER //
// ./containers/BuildingCard/components/ReserveSelect/components/ReserveSelectItem/constants.jsx